import { Injectable } from '@angular/core';
import { EntityState, EntityStore } from '@examdojo/state';
import { AdminUserStoreModel } from './admin-user.model';

export interface AdminUserState extends EntityState<AdminUserStoreModel> {}

@Injectable({ providedIn: 'root' })
export class AdminUserStore extends EntityStore<AdminUserState, AdminUserStoreModel, 'id'> {
  constructor() {
    super({
      name: 'admin-users',
      idKey: 'id',
    });
  }
}
